(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prison-client-week-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prison-week-bar')) {
    customElements.define('prison-week-bar', class extends HTMLElement {
      connectedCallback() {
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const preview = this.dataset.preview === 'true';
        const clock = this.querySelector('.ps-week-bar__clock');
        const time = this.querySelector('time');
        const tick = () => {
          const now = Date.now();
          const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
          this.hidden = !preview && (!valid || now < start || now >= end);
          clock.hidden = !valid || now < start || now >= end;
          if (!clock.hidden) {
            const total = Math.max(0, Math.ceil((end - now) / 1000));
            const days = Math.floor(total / 86400);
            const hours = Math.floor((total % 86400) / 3600);
            const minutes = Math.floor((total % 3600) / 60);
            const seconds = total % 60;
            time.dateTime = this.dataset.end;
            time.textContent = `${String(days).padStart(2,'0')}D : ${String(hours).padStart(2,'0')}H : ${String(minutes).padStart(2,'0')}M : ${String(seconds).padStart(2,'0')}S`;
          }
        };
        tick();
        this.interval = setInterval(tick, 1000);
        this.refreshClock = tick;
        document.addEventListener('visibilitychange', tick);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.refreshClock);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
